import { Navigate } from "react-router-dom";

// Alias route: `/auth/purchase-basic` was renamed to `/auth/purchase-plan`
// during the Phase 5 pricing rework. This redirect keeps the legacy path
// (and any external links / buttons pointing to it) functional.
export default function PurchaseBasicRedirect() {
  return <Navigate to="/auth/purchase-plan" replace />;
}
